import assign from 'lodash.assign';
export class ExternalReference {
    constructor(init) {
        assign(this, init);
    }
    uri;
    documentHash;
    hashAlgorithmMethod;
    expiryDate;
    expiryTime;
    mimeCode;
    formatCode;
    encodingCode;
    characterSetCode;
    fileName;
    description;
}
